import { useQuery } from '@tanstack/react-query';

import { fetchPaymentsGatewayName } from 'root/api/helpers';

import { OffendingRecord } from './types';

export const OFFENDING_RECORDS_URL_BASE = '/admin/offending';
export const OFFENDING_RECORDS_URL_META = '/admin/offending/meta';

export const PCI_COMPLIANCE_LIGHTSPEED_ARTICLE =
  'https://www.lightspeedhq.com/blog/what-is-pci-compliance/';

export const CUSTOMER_SAVED_PAYMENTS_LIGHTSPEED_ARTICLE =
  'https://retail-support.lightspeedhq.com/hc/{{locale}}/articles/38795393683995-Saving-customer-payment-methods-with-Lightspeed-Payments';

export const CUSTOMER_LIGHTSPEED_PAYMENTS_LIGHTSPEED_ARTICLE =
  'https://www.lightspeedhq.com/ecom/lightspeed-payments/';

export const GENERAL_ERROR = 'Something went wrong. Try again.';

export const numDaysBetween = (date1: Date, date2: Date) => {
  const diffTime = Math.abs(date2.getTime() - date1.getTime());
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};

export const showConfirmationSensitiveInformationCleaned = () =>
  window.flashNotifier('success', 'Sensitive information deleted', 3);

export const showConfirmationSensitiveInformationFlaggedForReview = () =>
  window.flashNotifier('success', 'Flagged for review', 3);

export const showErrorFlashNotifier = () => window.flashNotifier('warning', GENERAL_ERROR, 3);

export const fetchOffendingRecords = async (
  offset: number,
  pageSize: number
): Promise<{ offendingData: OffendingRecord[] }> => {
  const url = `/admin/offending/?pageSize=${pageSize}&offset=${offset}&isFalsePositive=false`;
  try {
    const res = await fetch(url);
    if (res.status !== 200) {
      throw new Error(`${GENERAL_ERROR}`);
    }
    const { data: Offending } = (await res.json()) || {};

    return { offendingData: Offending };
  } catch (error) {
    throw new Error(`${GENERAL_ERROR}`);
  }
};

export const useGatewayNameQuery = () =>
  useQuery({
    queryKey: ['gatewayName'],
    queryFn: () => {
      const accountId = window.merchantos.session.getSystemCustomerID();
      const shop = window.merchantos.session.getShop();
      if (!accountId || !shop || !shop.shopID) {
        return '';
      }
      return fetchPaymentsGatewayName({
        accountID: accountId.toString(),
        shopID: shop.shopID.toString(),
      });
    },
    retry: false,
    cacheTime: 300000, // 5 minutes
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
